import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "DamageDashboardPage" */
	'pages/vehicle/Damage/DamageDashboardPage'));

export default [{ component, exact: true, path: '/damages/:damageId' }];